import React, { useContext, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { format } from 'date-fns'
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext'
import { TimelineContext } from '../../../../../contexts/TimelineContext'
import TimelineHeaderUi from '../../../../Shared/TimelineParts/TimelineHeaderUi'

export default observer(function TimelineHeader({
  activeTab,
  onTabChange,
}) {
  const { campaign } = useContext(SharedCampaignContext)
  const { layout } = useContext(TimelineContext)

  const campaignDateRange = useMemo(() => {
    if (!campaign?.start_date || !campaign?.end_date) return null

    const startDate = new Date(campaign.start_date)
    const endDate = new Date(campaign.end_date)
    if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return null

    return `${format(startDate, 'dd.MM.yyyy')} - ${format(endDate, 'dd.MM.yyyy')}`
  }, [campaign?.start_date, campaign?.end_date])

  return (
    <TimelineHeaderUi
      campaign={campaign}
      dateRange={campaignDateRange}
      embedded={layout === 'embedded'}
      activeTab={activeTab}
      onTabChange={onTabChange}
    />
  )
})
